const floatChatBtn = () => {
  const chatBtn = $('.js-wa-chat-btn');

  const onScroll = () => {
    const sc = $(window).scrollTop();
    const distance = sc + $(window).height() - $('.site-footer').offset().top;
    if (sc > 200) {
      chatBtn.fadeIn(300);
    } else {
      chatBtn.fadeOut(200);
    }
    if ( distance >= 0 ) {
      chatBtn.css('transform', `translateY(-${distance}px)`)
    } else {
      chatBtn.css('transform', 'translateY(0px)')
    }
  }

  $(window).on('scroll', onScroll);
};

export default floatChatBtn;
